import React, { useEffect } from 'react'
import NavbarTop from '../components/global/NavbarTop'
import CaseStudiesCSContent from './../components/CaseStudies/CaseStudiesCSContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const CaseStudiesCS = () => {
  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('case-studies-cs-page.case-studies-cs-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesCSContent/>
        
    </>
  )
}

export default CaseStudiesCS